import React, { useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ApiGo from '../../../actions/ApiGo'
import WaitingIcon from '../../Login/wait/WaitingICON'
import zhTW from '../../../assets/i18n/zh-TW.json'

const AuditTrail = (props) => {
    const { t, i18n } = useTranslation()
    let _info = props.data
    const [auditTrailData, setAuditTrailData] = useState([]);

    function flattenJSON(obj, prefix = '') {
        return Object.keys(obj).reduce((acc, key) => {
            const fullKey = prefix ? `${prefix}.${key}` : key;
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                Object.assign(acc, flattenJSON(obj[key], fullKey));
            } else {
                acc[fullKey] = obj[key];
            }
            return acc;
        }, {});
    }

    const zhReverseMap = useMemo(() => {
        const flat = flattenJSON(zhTW);
        return Object.fromEntries(
            Object.entries(flat).map(([k, v]) => [v, k])
        );
    }, []);

    function renderAction(action) {
        if (!action) return '-';

        const statusWords = ['Success', 'success', 'failure', 'Failure', '成功', '失敗', '錯誤'];
        let status = '';
        let actionBody = action;

        for (const s of statusWords) {
            if (action.endsWith(` ${s}`)) {
                status = s;
                actionBody = action.slice(0, -(s.length + 1)).trim();
                break;
            }
        }

        const translateStatus = (s) => {
            if (!s) return '';
            const lower = s.toLowerCase();
            if (lower === 'success' || s === '成功') return t('GLOBAL.STATUS.SUCCESS');
            if (lower === 'failure' || s === '失敗') return t('GLOBAL.STATUS.FAILURE');
            if (s === '錯誤') return t('GLOBAL.STATUS.ERROR');
            return s;
        };

        // 情況 0：KEY/動態值 格式，例如 AUDIT_TRAIL.EVENTS.ROOMS/82
        if (/^[A-Z][A-Z0-9_.]+\/(.+)$/.test(actionBody)) {
            const keyPart = actionBody.split('/')[0];
            const dynamicPart = actionBody.split('/')[1];
            const translated = t(keyPart);
            const result = translated !== keyPart ? `${translated} ${dynamicPart}` : actionBody;
            return `${result} ${translateStatus(status)}`.trim();
        }

        // 情況 1：actionBody 是完整 i18n key（全大寫、底線、點組成）
        if (/^[A-Z][A-Z0-9_.]+$/.test(actionBody)) {
            const translated = t(actionBody);
            const result = translated !== actionBody ? translated : actionBody;
            return `${result} ${translateStatus(status)}`.trim();
        }

        // 情況 2：整句從 zh-TW 反查 key
        if (zhReverseMap[actionBody]) {
            return `${t(zhReverseMap[actionBody])} ${translateStatus(status)}`.trim();
        }

        // 情況 3：英文原文，嘗試拆詞各別反查
        const parts = actionBody.split(' ');
        const translated = parts.map(part => {
            if (zhReverseMap[part]) return t(zhReverseMap[part]);
            return part;
        }).join(' ');

        return `${translated} ${translateStatus(status)}`.trim();
    }

    function handleRole(_role) {
        switch (_role) {
            case "superdoctor": return t("GLOBAL.SUPERDOCTOR");
            case "doctor": return t("GLOBAL.DOCTOR");
            case "admin": return t("GLOBAL.ADMIN");
            default: break;
        }
    }

    useEffect(() => {
        ApiGo.getAudit_trail_get_single(_info.id)
            .then(res => { setAuditTrailData(res.reverse()) })
            .catch(err => {
                setAuditTrailData([{
                    action: "ADMIN.CONNECTION_HIS_PAGE.NO_AUDITTRAIL",
                    created_at: "T"
                }])
            })
    }, []);

    return (
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black" onClick={props.hide}>
            <div className="layout-history fx-d-c pad-30 l r" onClick={e => e.stopPropagation()}>
                <div className="h-100 fx-d-c w-100 font-ml pad-31">
                    <div className='w-90 fx-d-r fx-fsc h-10'>
                        <div className='font-xl'>
                            {(i18n.language === "en")
                                ? <>{_info.first_name} {_info.last_name}</>
                                : <>{_info.last_name}{_info.first_name}</>
                            }
                        </div>
                        <div className='font-l margl-xs'>{handleRole(_info.role)}</div>
                    </div>
                    <div className='w-100 h-90 ovy-a'>
                        <div className='frame-title bgTitle fx-d-r w-95 h-8'>
                            <div className='w-15 fx-ccc'>{t("GLOBAL.DATE")}</div>
                            <div className='w-15 fx-ccc'>{t("GLOBAL.TIME")}</div>
                            <div className='w-60 fx-fsc margl-m'>{t("AUDIT_TRAIL.AUDIT_TRAIL")}</div>
                        </div>
                        {(auditTrailData.length !== 0)
                            ? auditTrailData.map(res => (
                                <div className='frame-table fx-d-r w-95 h-8 font-m border' key={res.id}>
                                    <div className='w-15 fx-ccc'>{res.created_at.split("T")[0] || "-"}</div>
                                    <div className='w-15 fx-ccc'>{res.created_at.split("T")[1] || "-"}</div>
                                    <div className='font-s w-60 fx-fsc margl-s'>{renderAction(res.action)}</div>
                                </div>
                            ))
                            : <div className='w-100 h-60'><WaitingIcon page={"audit"} /></div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AuditTrail;